import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { useStudent } from './StudentContext';

export const GradientMark = ({ name, from, to, large = false }) => (
  <div
    className={`sa-gt${large ? ' lg' : ''}`}
    style={{ background: `linear-gradient(135deg, ${from}, ${to})` }}
  >
    <Icon name={name} />
  </div>
);

export const XpBadge = ({ amount, signed = true }) => (
  <span className="sa-xp">
    <Icon name="star" filled />
    {signed ? `+${amount}` : amount} XP
  </span>
);

export const MenuButton = () => {
  const { menuOpen, openMenu } = useStudent();

  return (
    <button
      type="button"
      className="sa-ib"
      aria-label="Menu"
      aria-expanded={menuOpen}
      onClick={openMenu}
    >
      <Icon name="menu" />
    </button>
  );
};

export const PageHeader = ({ title, backTo, right = null }) => {
  const navigate = useNavigate();

  return (
    <div className="sa-top">
      <MenuButton />
      {backTo ? (
        <button type="button" className="sa-ib" aria-label="Back" onClick={() => navigate(backTo)}>
          <Icon name="back" />
        </button>
      ) : null}
      <h1>{title}</h1>
      {right}
    </div>
  );
};

export const Chips = ({ group, options }) => {
  const { chips, setChip } = useStudent();

  return (
    <div className="sa-chips">
      {options.map((option) => (
        <button
          key={option}
          type="button"
          className={`sa-chip${chips[group] === option ? ' on' : ''}`}
          onClick={() => setChip(group, option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export const SectionTitle = ({ title, action, onAction }) => (
  <h2>
    {title}
    {action ? (
      <button type="button" className="sa-see" onClick={onAction}>
        {action}
      </button>
    ) : null}
  </h2>
);
